/**
 * Created by Kotkin on 18.07.17.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
// import numDesc from 'helpers/numDesc';
import formatDate from 'helpers/formatDate';
import beautifyNumber from 'helpers/beautifyNumber';
import { I18nHoc } from 'helpers/i18n';
import { authConnect } from 'auth';
// import Perms from 'auth/perms';
// import DataProvider from 'api/data-provider';
// import Link from 'components/link';
import Button from 'components/button';
import { Thumb } from 'components/image';
// import Row, { Col } from 'components/row';
import DropDown from 'components/drop-down';
import Icon, { iconTypes } from 'components/icon';

// import linksForum from 'src-sites/forum/links';
// import linksBackOffice from 'src-sites/backoffice/links';

import 'styles/forum/subsys/card-info/_card-info.scss';

import translates from './card-info-i18n.json';

const bemClasses = new Bem('cardInfo');
const bemClassesDD = new Bem('dropdown');

@authConnect()
@I18nHoc(translates)
export default class CardInfo extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    userPhoto: PropTypes.shape({}),
    dataObj: PropTypes.shape({}),
    userName: PropTypes.string,
    device: PropTypes.string,
    userId: PropTypes.number,
    userIsOp: PropTypes.bool
  };

  /*
  //TODO Веталь нужно выпилить стили
  showUserData =({ data })=> {
    const { i18n } = this;
    const {
      checkPermission, userPhoto, userName, userId = {}
    } = this.props;
    const profile = get(data, '[0]');
    if (!profile) return null;

    return (
      <div {...bemClasses()}>
        <Row {...bemClasses('row')}>
          <Col {...bemClasses('col', 'img')} allAuto allPr={0}>
            <div {...bemClasses('imgContainer')}>
              <div {...bemClasses('img')}>
                {userPhoto ?
                  <Thumb
                    {...bemClasses('imgPic')}
                    image={userPhoto}
                  /> :
                  <Icon {...bemClasses('icon')} type={iconTypes.personCircle} />
                }
              </div>
            </div>
          </Col>
          <Col {...bemClasses('col', 'info')} allPr={0}>
            <div {...bemClasses('item', 'name')}>
              {checkPermission(Perms.FORUM_CONTROL_ALL_TOPIC) &&
                <Link
                  {...bemClasses('link', 'name')}
                  builder={linksBackOffice.pageAllUsersEditor}
                  builderProps={{
                    hash: `?id=${this.props.userId}`,
                    title: 'Профиль'
                  }}
                  noRedirector
                  external
                  blank
                >
                  <span {...bemClasses('linkContent')}>
                    <span {...bemClasses('text')} children={userName || get(profile, 'forum_nick')} />
                  </span>
                </Link>
              }
            </div>
            <div {...bemClasses('item', 'rank')}>
              <span {...bemClasses('text')} children={get(profile, 'user_rank.name')} />
            </div>
          </Col>
        </Row>
        <div {...bemClasses('main')}>
          <div {...bemClasses('item', 'id')}>
            <span {...bemClasses('text', 'label')} children="ID: " />
            <span {...bemClasses('text')} children={userId} />
          </div>
          <div {...bemClasses('item', 'views')}>
            <span {...bemClasses('text', 'label')} children={i18n('profileViews')} />
            <span {...bemClasses('text')} children={get(profile, 'profile_views', 0)} />
          </div>
          <div {...bemClasses('item', 'date')}>
            <span {...bemClasses('text', 'label')} children={i18n('login')} />
            <span
              {...bemClasses('text')}
              children={formatDate({
                date: profile.date_add,
                render: 'date',
                format: 'dd.mm.yyyy'
              })}
            />
          </div>
          <div {...bemClasses('item', 'from')}>
            <span {...bemClasses('text', 'label')} children={i18n('from')} />
            <span {...bemClasses('text')} children={i18n('country')} />
          </div>
          {this.showForumFields(profile)}
        </div>
      </div>
    );
  }

  showForumFields = (profile) => {
    const { i18n } = this;
    return (
      <>
        <div {...bemClasses('item', 'karma')}>
          <span {...bemClasses('text', 'label')} children={i18n('userKarma')} />
          <span {...bemClasses('text')} children={get(profile, 'user_karma')} />
        </div>
        <div {...bemClasses('item', 'posts')}>
          <span {...bemClasses('text', 'label')} children={i18n('posts')} />
            <Link
              {...bemClasses('link', 'inline posts')}
              builder={linksForum.sectionUserPosts}
              builderProps={{
                user_id: this.props.userId,
              }}
              external
            >
              <span {...bemClasses('linkContent')}>
                <span {...bemClasses('text')} children={get(profile, 'user_posts')} />
              </span>
            </Link>
          <span {...bemClasses('text')} children={` / ${get(profile, "postsPerDay") ? profile.postsPerDay : 0} в день`} />
        </div>
        <div {...bemClasses('item', 'present')}>
          <span {...bemClasses('text', 'label')} children={i18n('lastTimeWas')} />
          <span {...bemClasses('text')} children={i18n('noData')} />
        </div>
        {get(profile, 'topics') &&
          <div {...bemClasses('item', 'topic')}>
            <span {...bemClasses('text', 'label')} children={i18n('favoriteTopic')} />
            <Link
              {...bemClasses('link', 'inline topic')}
              builder={linksForum.sectionTopic}
              builderProps={{
                ...profile.topics[0]
              }}
              external
            >
              <span {...bemClasses('linkContent')}>
                <span
                  {...bemClasses('text')}
                  dangerouslySetInnerHTML={{__html: `${profile.topics[0].topic_title}`}} // eslint-disable-line
                />
              </span>
            </Link>
            <Link
              {...bemClasses('link', 'inline viewAll')}
              builder={linksForum.sectionUserTopics}
              builderProps={{
                user_id: this.props.userId,
              }}
              external
            >
              <span {...bemClasses('linkContent')}>
                <span {...bemClasses('text')} children={i18n('lookAll')} />
              </span>
            </Link>
          </div>
        }
        {!!get(profile, 'club_member_count') &&
          <div {...bemClasses('item', 'clubCount')}>
            <Link
              {...bemClasses('link', 'inline clubCount')}
              builder={linksForum.sectionUserClubs}
              builderProps={{
                user_id: this.props.userId,
              }}
              external
            >
              <span {...bemClasses('linkContent')}>
                <span {...bemClasses('text')}>{i18n('member')}Член {numDesc(beautifyNumber(profile.club_member_count), 'клуба', 'клубов', 'клубов')}</span>
              </span>
            </Link>
          </div>
        }
        {!!get(profile, 'has_voting') &&
          <div {...bemClasses('item', 'voting')}>
            <Link
              {...bemClasses('link', 'inline voting')}
              builder={linksForum.sectionUserVotes}
              builderProps={{
                user_id: this.props.userId,
              }}
              external
            >
              <span {...bemClasses('linkContent')}>
                <span {...bemClasses('text')} children={i18n('takePart')} />
              </span>
            </Link>
          </div>
        }
        {!!get(profile, 'give_karma') &&
          <div {...bemClasses('item', 'karmaGive')}>
            <span {...bemClasses('text', 'label')} children="Выдал репутацию: " />
            <span {...bemClasses('text', 'label')} children={get(profile, 'give_karma') || 0} />
          </div>
        }
      </>
    )
  };
  */

  render() {
    const { i18n, i18nGetLang } = this;
    const lang = i18nGetLang();
    const {
      userName, className, /*userId = {},*/ userIsOp, dataObj = {}, device, userPhoto
    } = this.props;
    const isDesktop = device === 'desktop';
    const userIsOfficial = get(dataObj, 'user_official_account');
    let btnProps = {
      title: `${i18n('visitCard')} ${userName}`,
      label: userName,
      //iconSecondType: iconTypes.carretBild,
      noPadding: true
    };
    const avatarTitle = userName ? userName.split(' ').map(lt => lt[0]).join('').slice(0, 2) : null;

    if (isDesktop) {
      btnProps = {
        ...btnProps,
        label: false,
        noPadding: false,
        // customRenderer: true,
        children: (
          <div {...bemClassesDD('btnContent')}>
            <div {...bemClasses('text', 'name')} children={userName} />
            <div {...bemClasses('imgContainer')}>
              <span {...bemClasses('img')}>
                {!!userPhoto ?
                  <Thumb
                    {...bemClasses('imgPic')}
                    image={userPhoto}
                    tagSpan
                  /> :
                  <span {...bemClasses('imgPic', 'icon')} children={avatarTitle} />
                }
              </span>
              {userIsOp && <span {...bemClasses('icon', 'text', 'icon btn__icon')} children="ОП" />}
              {userIsOfficial && <Icon {...bemClasses('icon')} type={iconTypes.anglesMultiCheck} />}
            </div>
            {!!dataObj.userRank &&
              <div {...bemClasses('text', 'post')} children={dataObj.userRank} />
            }
            <div {...bemClasses('text', 'amountPosts')}>
              <Icon {...bemClasses('icon', 'amountPosts')} type={iconTypes.commentRound} />
              <span children={beautifyNumber(dataObj.user_all_posts) || 0} />
            </div>
            {!!dataObj.u_date_add &&
              <div
                {...bemClasses('text', 'date')}
                children={
                  formatDate({
                    date: get(dataObj.u_date_add.split(' '), '[0]'),
                    render: 'date',
                    format: 'dd mmmm yyyy'
                  }, lang)
                }
              />
            }
            {/*!!dataObj.user_karma && TODO эти данные пока не выводить
              <div {...bemClasses('text', 'rank')} children={`${i18n('rate')} (${dataObj.user_karma})`} />
            */}
          </div>
        )
      }

      return (
        <div
          {...bemClasses('btn', 'cardInfo', className)}
          {...btnProps}
        />
      );
    }

    if (userIsOp) btnProps = {
      ...btnProps,
      customRenderer: true,
      children: (
        <span {...bemClassesDD('btnContent')}>
          <span {...bemClassesDD('icon', 'text', 'icon btn__icon')} children="ОП" />
          <span {...bemClassesDD('text', null, 'btn__text')} children={userName} />
          {/*<Icon {...bemClassesDD('icon', 'second', 'btn__icon btn__icon_second')} type={iconTypes.carretBild} />*/}
        </span>
      )
    }

    if (userIsOfficial) btnProps = {
      ...btnProps,
      iconType: iconTypes.anglesMultiCheck
    }

    return (
      <DropDown
        {...bemClasses('dd')}
        disableContent
        alwaysDD
      >
        <Button
          {...bemClasses('btn', 'cardInfo', className)}
          {...btnProps}
        />
        <div {...bemClasses('content')}>
          {/*
          <DataProvider
            url="domik/users/users"
            query={{ 'user-id': userId }}
            renderer={this.showUserData}
          />
          */}
        </div>
      </DropDown>
    )
  }
}
